/* eslint-disable */
import * as Types from '../../../../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarkAllMessagesAsReadMutationVariables = Types.Exact<{
  input: Types.MarkAllMessagesAsReadInput;
}>;

export type MarkAllMessagesAsReadMutation = {
  __typename?: 'Mutation';
  markAllMessagesAsRead: {
    __typename?: 'BasicMutationPayload';
    success: boolean;
  };
};

export const MarkAllMessagesAsReadDocument = gql`
  mutation markAllMessagesAsRead($input: MarkAllMessagesAsReadInput!) {
    markAllMessagesAsRead(input: $input) {
      success
    }
  }
`;
export type MarkAllMessagesAsReadMutationFn = Apollo.MutationFunction<
  MarkAllMessagesAsReadMutation,
  MarkAllMessagesAsReadMutationVariables
>;

/**
 * __useMarkAllMessagesAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllMessagesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllMessagesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllMessagesAsReadMutation, { data, loading, error }] = useMarkAllMessagesAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAllMessagesAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllMessagesAsReadMutation,
    MarkAllMessagesAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkAllMessagesAsReadMutation,
    MarkAllMessagesAsReadMutationVariables
  >(MarkAllMessagesAsReadDocument, options);
}
export type MarkAllMessagesAsReadMutationHookResult = ReturnType<
  typeof useMarkAllMessagesAsReadMutation
>;
export type MarkAllMessagesAsReadMutationResult =
  Apollo.MutationResult<MarkAllMessagesAsReadMutation>;
export type MarkAllMessagesAsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkAllMessagesAsReadMutation,
  MarkAllMessagesAsReadMutationVariables
>;
